import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import logoSvart from "@/assets/logo-svart.webp";

const navLinks = [
  { label: "PRODUKTER", path: "/produkter" },
  { label: "VÅR TJÄNST", path: "/tjanster" },
  { label: "OM OSS", path: "/om-oss" },
  { label: "BESTÄLL", path: "/pricing" },
  { label: "KONTAKT", path: "/kontakt" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 left-0 right-0 z-50 backdrop-blur-md bg-cream-100/90 shadow-sm animate-slide-down">
      <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto">
        <Link to="/" className="flex items-center gap-2">
          <img src={logoSvart} alt="aQuadias" className="h-6 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 ${
                location.pathname === link.path
                  ? "text-terracotta-500 border-b-2 border-terracotta-500"
                  : "text-foreground hover:text-terracotta-500"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/account"
            className="hidden md:flex items-center gap-1 text-sm font-medium text-foreground hover:text-terracotta-500 transition-colors"
          >
            <User className="w-4 h-4" />
            Konto
          </Link>
          <Link
            to="/pricing"
            className="hidden md:inline-flex bg-terracotta-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-terracotta-600 transition-all duration-300"
          >
            Beställ nu
          </Link>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden p-2 rounded-full hover:bg-terracotta-100 transition-colors"
            aria-label={menuOpen ? "Stäng meny" : "Öppna meny"}
          >
            {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-cream-100 border-t border-border px-6 py-6 space-y-4 animate-fade-in">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className="block text-sm font-medium text-foreground hover:text-terracotta-500 transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-4 border-t border-border space-y-3">
            <Link
              to="/account"
              onClick={() => setMenuOpen(false)}
              className="block text-sm font-medium text-foreground"
            >
              Konto
            </Link>
            <Link
              to="/pricing"
              onClick={() => setMenuOpen(false)}
              className="block w-full bg-terracotta-500 text-white px-6 py-3 rounded-full text-sm font-medium text-center hover:bg-terracotta-600 transition-all"
            >
              Beställ nu
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
